import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { metadatas } from '@sorare/core/src/lib/seo/common';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { AboutUs } from './AboutUs';
import { ByTheNumbers } from './ByTheNumbers';
import { HowToPlay } from './HowToPlay';
import { InTheNews } from './InTheNews';
import { Intro } from './Intro';
import { Leadership } from './Leadership';

const Root = styled(Vertical).attrs({
  gap: 4,
  center: true,
})`
  margin-top: var(--double-unit);
  @media ${tabletAndAbove} {
    padding: var(--double-unit);
  }
`;

export const Press = () => {
  useTitleAndDescription(metadatas.press.title);

  return (
    <Root>
      <Intro />
      <AboutUs />
      <HowToPlay />
      <ByTheNumbers />
      <Leadership />
      <InTheNews />
    </Root>
  );
};
